import { useCurrentChannel } from './query/useCurrentChannel';

export const useIsNeedlPublishedFeed = () => {
  const channelInfo = useCurrentChannel();
  return { isNeedlPublishedFeed: !!channelInfo?.needl_feed };
};
